import React, { useMemo } from 'react';
import { BarChart2 } from 'lucide-react';

import { useEditableEvent } from '@event-editor/hooks/useEditableEvent';
import { EventPublishScheduleStatus } from 'types/event.types';

export const EmptyQuestionnaireResponses = (): React.ReactElement => {
  const { guestListTotals, isPublished, publishSchedule } = useEditableEvent();

  const emptyResponsesText = useMemo(() => {
    const isDraft = !isPublished;
    const hasPublishSchedule = publishSchedule?.status === EventPublishScheduleStatus.SCHEDULED;
    const isPublishedWithNoGuests = isPublished && guestListTotals?.confirmed === 0;
    const isPublishedWithGuests =
      isPublished && guestListTotals?.confirmed && guestListTotals.confirmed > 0;

    if (isDraft) {
      if (hasPublishSchedule) {
        return 'Guests can register for the event after it is published';
      }

      return 'Publish the event to receive responses';
    }
    if (isPublishedWithNoGuests) {
      return 'No guests have registered for the event yet';
    }
    if (isPublishedWithGuests) {
      return 'Guests have not submitted questionnaire responses';
    }
    return '';
  }, [isPublished, guestListTotals]);

  return (
    <div className="tw-flex tw-flex-col tw-items-center tw-justify-center tw-rounded-md tw-border tw-border-dashed tw-border-border-grey tw-py-5 tw-text-center">
      <BarChart2 className="tw-mb-1 tw-text-medium-grey" strokeWidth={3} />
      <h3 className="tw-mb-0.5 tw-text-sm tw-font-normal tw-leading-5 tw-text-primary-grey">
        No responses yet
      </h3>
      <p className="tw-mb-0 tw-text-xs tw-leading-4 tw-text-primary-grey">{emptyResponsesText}</p>
    </div>
  );
};
